import { Fragment } from 'react';

/** Split CMS text on Enter / <br> tags into safe React nodes. */
export function splitCmsBreaks(text) {
  return String(text ?? '')
    .replace(/\r\n/g, '\n')
    .split(/<br\s*\/?>|\n/gi);
}

export function CmsBreakText({ text, as: Comp = 'span', className }) {
  const parts = splitCmsBreaks(text);
  if (!parts.length || (parts.length === 1 && !parts[0])) {
    return Comp === 'span' ? null : <Comp className={className} />;
  }
  return (
    <Comp className={className}>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {i > 0 ? <br /> : null}
          {part}
        </Fragment>
      ))}
    </Comp>
  );
}
